module.exports = __webpack_public_path__ + "static/media/metaverse.fb8cd98a.jpg";